import { Component, Input, OnInit } from '@angular/core';
import { UploadComponent } from '../../../shared/components/upload/upload.component';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { BaseComponent } from '../../../shared/utils/base.component';
import { SectionsService } from '../../../services/sections.service';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { ReferralDataService } from '../../../services/referral-data.service';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import {
  ENROLLMENT_TYPE_BACKEND_MAPPINGS,
  ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS,
  STATIC_DATA,
  STATIC_JSON_DATA_PATH,
} from '../../../shared/constants/static-data.constants';
import { CommonModule } from '@angular/common';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { FileUploadComponent } from '../../lead-details/documents/file-upload/file-upload/file-upload.component';
import { SharedService } from '../../../shared/services/shared.service';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { AutoFocusHeaderDirective } from '../../../shared/directives/auto-focus-header.directive';
import { MultiselectComponent } from '../../../shared/components/multiselect/multiselect.component';
import { LookupService } from '../../../services/lookup.service';
@Component({
  selector: 'ppl-upload-docs',
  standalone: true,
  imports: [
    UploadComponent,
    MultiselectComponent,
    NzCardModule,
    NzGridModule,
    NzFormModule,
    ReactiveFormsModule,
    FormsModule,
    ListTableComponent,
    CommonModule,
    FileUploadComponent,
    AutoFocusHeaderDirective,
  ],
  templateUrl: './upload-docs.component.html',
  styleUrl: './upload-docs.component.css',
})
export class UploadDocsComponent extends BaseComponent implements OnInit {
  @Input() mode = 'edit';
  licences: any[] = [];
  uploadDocsForm!: FormGroup;
  fileList: any = [];
  formHasBeenFilled: any;
  filledInfo: any = {};
  cols: any[] = [];
  flow: any;
  leadId: any;
  steps: any;
  showFileList = false;
  isMobileView = window.innerWidth < 768;
  program: any;

  constructor(
    private sectionsService: SectionsService,
    private referralDataService: ReferralDataService,
    private fb: FormBuilder,
    private userService: UserService,
    private sharedService: SharedService,
    private storageService: StorageService,
    private leadDetailsService: LeadDetailsService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.getFileCols();

    this.uploadDocsForm = this.fb.group({
      filesUploaded: [[]],
    });

    this.program = this.userService.getSelectedProgram();
    this.steps = this.sectionsService.getSectionData(
      this.program?.program_code,
    );
    this.secData = this.steps['upload_docs'];
    this.flow = this.sectionsService.getFlow();

    this.uploadDocsForm.valueChanges.subscribe(() => {
      this.fileList = this.uploadDocsForm.value.filesUploaded;
      const hasValue = this.hasAnyValueInForm(this.uploadDocsForm);
      this.formHasBeenFilled = hasValue;
      this.referralDataService.setReferralFormData(
        'isUploadFormUpdated',
        this.formHasBeenFilled,
      );

      this.referralDataService.setReferralFormData(
        'filesUploaded',
        this.uploadDocsForm.value,
      );
      this.referralDataService.setReferralFormData(
        'isUploadFormDirty',
        this.uploadDocsForm.dirty,
      );
      if (this.fileList.length > 0) {
        this.referralDataService.setReferralFormData('isUploadFormDirty', true);
      }
    });

    if (
      this.sectionsService.getFlow() == 'referral' &&
      this.userService.getLeadEntry() == 'referral' &&
      !this.referralDataService.getReferralFormData().filesUploaded
    ) {
      const filledData =
        this.referralDataService.getReferralDetails('filesUploaded')!;
      if (filledData) {
        this.uploadDocsForm.patchValue(filledData);
      }
    }

    if (this.referralDataService.getReferralFormData().filesUploaded) {
      this.filledInfo =
        this.referralDataService.getReferralFormData().filesUploaded;
      this.uploadDocsForm.patchValue(this.filledInfo);
    }

    this.referralDataService.nextClicked.subscribe(() => {
      if (this.fileList.length > 0) {
        this.referralDataService.setError([]);
      }
    });
    if (this.flow === STATIC_DATA.REFERRAL) {
      this.showFileList = true;
    }
    this.leadId = '';
    if (this.flow === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
      this.leadId = this.storageService.getParticipantId();
      this.getDocumentsUploaded();
    }
    if (this.flow === STATIC_DATA.PROVIDER_ENROLLMENT) {
      this.leadId = this.storageService.getProviderId();
      this.getDocumentsUploaded();
    }
    if (this.flow === STATIC_DATA.REFERRAL) {
      this.leadId = this.storageService.getReferralId();
    }
    if (this.flow === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
      const docsPayload = {
        associationTypes: ['PTC'],
        programCode: this.program.program_code,
      };
      this.lookupService
        .getDocumentsLookup(docsPayload)
        .subscribe((data: any) => {
          console.log('docs list custom', data.responsedata);
          this.licences = data.responsedata[0].lookupValue;
        });
    } else if (this.flow === STATIC_DATA.PROVIDER_ENROLLMENT) {
      this.leadDetailsService
        .fetchLeadDetailsApi(
          this.flow,
          this.program.program_code,
          Number(this.leadId),
        )
        .subscribe((data) => {
          const associations = data?.responsedata?.participantAssociations;
            if (!associations) {
              this.licences = [];
              return;
            }
          const providerTypesList = associations
            .filter((provider: any) =>
              provider.associationStatus !== 'Disassociated',
            )
            .map(
              (provider: any) =>
                ENROLLMENT_TYPE_BACKEND_MAPPINGS[provider.providerType],
            );
          if (providerTypesList.length > 0) {
            const mappedList = providerTypesList.map(
              (item: any) => ENROLLMENT_TYPE_UI_TO_BACKEND_MAPPINGS[item],
            );

            const docsPayload = {
              associationTypes: mappedList,
              programCode: this.program.program_code,
            };
            this.lookupService
              .getDocumentsLookup(docsPayload)
              .subscribe((data: any) => {
                console.log('docs list custom', data.responsedata);
                this.licences = data.responsedata[0].lookupValue;
              });
          } else {
            this.licences = [];
          }
        });
    } else {
      this.licences = this.getLookup('License_Type');
    }
  }

  filesUpdated() {
    console.log('Files List update');
    this.getDocumentsUploaded();
  }

  filesUploaded(files: any) {
    this.uploadDocsForm.patchValue({
      filesUploaded: files,
    });
    if (
      this.flow === STATIC_DATA.PARTICIPANT_ENROLLMENT ||
      this.flow === STATIC_DATA.PROVIDER_ENROLLMENT
    ) {
      this.getDocumentsUploaded();
    }
  }

  async getFileCols() {
    const tempCols = await this.sectionsService.getJsonConfigurationData(
      STATIC_JSON_DATA_PATH.FILE_UPLOAD_HEADERS,
    );
    this.cols = tempCols?.documents?.columns;
  }

  hasUploadedFile(): boolean {
    return (
      this.filledInfo['filesUploaded'] &&
      this.filledInfo['filesUploaded'].length > 0
    );
  }

  getDocumentsUploaded() {
    const program = this.userService.getSelectedProgram();
    const flow = this.sectionsService.getFlow()!;
    this.sharedService
      .getUploadedFileDetails(program?.program_code ?? '', this.leadId, flow)
      .subscribe((data) => {
        this.filledInfo = data?.responsedata;
      });
  }
}
